<template>
  <div class="AgentList">
    <createAppVue
      v-if="createAppFlag"
      @changeFlag="change_create_app_flag"
      :edit_item_data="edit_item_data"
      :active_type_tab="active_type_tab"
      :modeType="modeType"
      :checkMode="checkMode"
    ></createAppVue>
    <ManTag
      v-if="ManTagFlag"
      @change_man_tag_flag="change_man_tag_flag"
      :labels_all="labelsList"
      @get_lable="get_lable"
    ></ManTag>
    <div
      class="showItemBox"
      id="showItemBox"
      ref="showItemBoxRef"
      @scroll="handleScroll"
    >
      <div class="agent-item create-app addAppBox" style="flex-direction: row">
        <div class="aab_type1" @click="createApp()">
          <h3>{{ lang.newApplication }}</h3>
          <span>{{ lang.create_app_blank }}</span>
          <div>{{ lang.goToNew }} →</div>
          <img class="addAppIcon" src="@/assets/img/appCenter/addAppIcon.png" />
        </div>
        <div
          class="aab_type2"
          v-if="!shouldHideAgentShortcuts"
          @click="file_import()"
        >
          <h3>{{ lang.fileImport }}</h3>
          <span>{{ lang.file_import }}</span>
          <div>{{ lang.de_import }} →</div>
          <img class="addAppIcon" src="@/assets/img/appCenter/fileImport.png" />
        </div>
        <div
          class="aab_type3"
          v-if="!shouldHideAgentShortcuts && user.type !== USER_TYPE_CONSTANTS.STUDENT_TYPE"
          @click="createAppModel()"
        >
          <h3>{{ lang.templateCreation }}</h3>
          <span>{{ lang.create_app_model }}</span>
          <div>{{ lang.templateSelection }} →</div>
          <img
            class="addAppIcon"
            src="@/assets/img/appCenter/templateCreatrion.png"
          />
        </div>
      </div>
      <div
        v-for="(item, index) in AgentList"
        :key="item.id + index"
        class="agent-item poin"
        @click="line_agent(item)"
      >
        <div class="cardItem_top">
          <div class="ci_t_top">
            <div class="ci_t_t_left">
              <img v-if="item.headUrl" :src="item.headUrl" />
              <img
                v-else-if="item.source == 'mutiagent' || item.source == 'aiedit'"
                :src="muti_default_avatar[0]"
              />
              <img
                v-else-if="item.source == 'agent'"
                :src="agent_default_avatar[2]"
              />
              <!-- <img v-else :src="active_type_tab == 1?agent_default_avatar[2]:muti_default_avatar[0]" /> -->
            </div>
            <div class="ci_t_t_right">
              <div class="ci_t_t_r_top">
                <el-tooltip
                  placement="top"
                  effect="light"
                  :content="item.name || item.assistantName"
                >
                  <span>{{ item.name || item.assistantName }}</span>
                </el-tooltip>
                <div>
                  <!-- <span
                    class="ci_t_r_m_collect"
                    @click.stop="handle_collect(item)"
                  >
                    <img
                      v-if="item.isCollect == 1"
                      src="@/assets/img/appCenter/collect_active.svg"
                    />
                    <img
                      v-else
                      src="@/assets/img/appCenter/collect_default.svg"
                    />
                  </span> -->
                  <div class="ci_t_r_m_popover">
                    <div
                      class="ac_c_i_t_p_box"
                      v-if="editAppCard === item.id"
                      v-click-outside="handleBlur"
                      @click.stop="StopUP"
                    >
                      <!-- <div @click.stop="edit_item(item)">
                        <span>{{ lang.edit }}</span>
                      </div>
                      <div @click.stop="viewCard(item)" v-if="item.source != 'aiedit'">
                        <span>{{ lang.view }}</span>
                      </div> -->
                      <div @click.stop="handle_collect(item)">
                        <span>
                          {{
                            item.isCollect ? lang.unfavorite : lang.favorite
                          }}</span
                        >
                      </div>
                      <div v-if="item.status==1" @click="unpublish2(item)">
                        <span>{{ lang.unpublish }}</span>
                      </div>
                      <div v-if="item.isEditable" @click.stop="copy_item(item)">
                        <span> {{ lang.copy_muti_agent }}</span>
                      </div>
              
                      <div @click.stop="delete_item(item, index)">
                        <span>{{ lang.delete }}</span>
                      </div>
                    </div>
                    <svg
                      t="1732786015570"
                      @click.stop="updateCard(item.id)"
                      :style="`transform: rotate(${
                        editAppCard === item.id ? '90deg' : '0deg'
                      });background-color:${
                        editAppCard === item.id ? '#F3F7FD' : '#fff'
                      };transition:.3s`"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9199"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                        fill="#111111"
                        p-id="9200"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="ci_t_t_r_bottom">
                <span
                  >{{
                    new Date(createtime_add8(item.updatetime))
                      .toLocaleString()
                      .replaceAll('/', '-')
                  }}
                  {{ lang.edit }}</span
                >
                <div v-if="item.source == 'mutiagent'">
                  <img
                    src="../../assets/img/appCenter/appManagement/workflow.svg"
                    alt=""
                  />
                  {{ lang.workflow }}
                </div>
                <div v-if="item.source == 'agent'">
                  <img
                    src="../../assets/img/appCenter/appManagement/agent.svg"
                    alt=""
                  />
                  {{ lang.agent }}
                </div>
                <div v-if="item.source == 'aiedit'" style="flex-shrink: 0;">
                  <img
                    src="../../assets/img/appCenter/appManagement/agent.svg"
                    alt=""
                  />
                  {{ lang.aiCode }}
                </div>
              </div>
            </div>
          </div>
          <div class="ci_t_bottom">
            <el-tooltip
              placement="top-start"
              popper-class="tooltipMaxWidth"
              effect="light"
              v-if="item.description"
              :content="item.description"
            >
              <div class="ci_t_r_brief">{{ item.description }}</div>
            </el-tooltip>
          <!-- <div class="ci_t_left">
						<div>
							<img v-if="item.headUrl" :src="item.headUrl" />
							<img v-else :src="active_type_tab == 1? require('@/assets/img/appCenter/agent_default_avatar.svg'):muti_default_avatar[0]" />
						</div>
					</div>
					<div class="ci_t_right">
						<div class="ci_t_r_message">
							<div>
								<el-tooltip
									placement="top"
									effect="light"
									:content="item.name || item.assistantName"
								>
									<span>{{ item.name || item.assistantName }}</span>
								</el-tooltip>
								<div>
									<span
										class="ci_t_r_m_collect"
										@click.stop="handle_collect(item)"
									>
										<img
											v-if="item.isCollect == 1"
											src="@/assets/img/appCenter/collect_active.svg"
										/>
										<img
											v-else
											src="@/assets/img/appCenter/collect_default.svg"
										/>
									</span>
									<div class="ci_t_r_m_popover">
										<div
											class="ac_c_i_t_p_box"
											v-if="editAppCard === item.id"
											v-click-outside="handleBlur"
											@click.stop="StopUP"
										>
											<div @click.stop="edit_item(item)">
												<span>{{ lang.edit_information }}</span>
											</div>
											<div @click.stop="line_agent(item)">
												<span>{{ lang.view }}</span>
											</div>
											<div @click.stop="handle_collect(item)">
												<span>
													{{
														item.isCollect ? lang.cancel_collect : lang.collect
													}}</span
												>
											</div>
											<div @click.stop="copy_item(item)">
												<span> {{ lang.copy_muti_agent }}</span>
											</div>
											<div @click.stop="delete_item(item, index)">
												<span>{{ lang.delete }}</span>
											</div>
										</div>
										<svg
											t="1732786015570"
											@click.stop="updateCard(item.id)"
											:style="`transform: rotate(${
												editAppCard === item.id ? '90deg' : '0deg'
											});background-color:${
												editAppCard === item.id ? '#F3F7FD' : '#fff'
											};transition:.3s`"
											class="icon"
											viewBox="0 0 1024 1024"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											p-id="9199"
											width="200"
											height="200"
										>
											<path
												d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
												fill="#111111"
												p-id="9200"
											></path>
										</svg>
									</div>
								</div>
							</div>
							<div>
								<span
								>{{
									new Date(createtime_add8(item.updatetime))
										.toLocaleString()
										.replaceAll("/", "-")
								}}
								{{ lang.edit }}</span
							>
							<div v-if="item.source=='mutiagent'">
										<img
											src="../../assets/img/appCenter/appManagement/workflow.svg"
											alt=""
										/>
										{{ lang.workflow }}
									</div>
									<div v-if="item.source=='agent'">
										<img
											src="../../assets/img/appCenter/appManagement/agent.svg"
											alt=""
										/>
										{{ lang.agent }}
									</div>
							</div>
						</div>
						<el-tooltip
							placement="top-start"
							effect="light"
							v-if="item.description"
							:content="item.description"
						>
							<div class="ci_t_r_brief">{{ item.description }}</div>
						</el-tooltip>
					</div> -->
        </div>
        </div>
        <div class="cyN" v-if="item.cyid">
            {{ lang.From }} {{ cyname(item.cyid) }}
        </div>
        <div class="cardItem_bottom">
          <div class="ci_b_left" @click.stop="">
            <div class="icon">
              <el-tooltip
                placement="top"
                effect="light"
                :content="lang.view"
              >
                <img
                  :src="require('@/assets/img/lookeye.svg')"
                  :class="{ 'icon-disabled': item.status != 1 }"
                  @click.stop="item.status == 1 ? viewCard(item) : null"
                  class="icon-btn"
                />
              </el-tooltip>
              <el-tooltip
                placement="top"
                effect="light"
                :content="lang.edit"
              >
                <img
                  :src="require('@/assets/img/edit.svg')"
                  @click.stop="line_agent(item)"
                  class="icon-btn"
                />
              </el-tooltip>
            </div>
            <el-popover
              trigger="click"
              placement="bottom"
              popper-class="popoverBox"
              :width="180"
              @after-leave="
                () => {
                  tagSearchValue = '';
                }
              "
              v-if="false"
            >
              <template #reference>
                <div
                  class="flex_x_item desc poin add_tag ci_b_l_box"
                  @click="
                    (item.add_tag = true),
                    (item.labels2 = JSON.parse(JSON.stringify(item.labels)))
                  "
                  style="width: 100%"
                >
                  <i class="iconfont cocoflow-biaoqian mr-5"></i>
                  <span v-if="item.isEditable">
                    <div class="flex_x tagNowWrap" v-if="item.labels.length">
                      {{ tagCom(item.labels) }}
                    </div>
                    <p v-else>{{ lang.add_tag }}</p>
                  </span>
                  <span v-else>
                    <div class="tagNowWrap">
                      从模板创建
                    </div>
                  </span>
                </div>
              </template>
              <div class="man_tagBox">
                <div class="m_tb_top" v-if="labels_all.length > 0">
                  <el-input
                    v-model="tagSearchValue"
                    :placeholder="lang.search"
                    size="small"
                    @keyup.enter.native="selectTagBox"
                  >
                    <i
                      slot="suffix"
                      class="el-icon-search"
                      style="font-size: 16px; margin-top: 7px"
                      @click="selectTagBox"
                    ></i>
                  </el-input>
                </div>
                <div class="m_tb_center" v-if="labels_all.length > 0">
                  <el-checkbox-group
                    class="flex_y"
                    trigger="hover"
                    v-model="item.labels"
                    @change="
                      (e) => {
                        add_tag(e, item);
                      }
                    "
                  >
                    <el-checkbox
                      class="m_tb_c_checkboxItem"
                      v-for="(labels, labels_all_index) in labels_allFilter"
                      :key="labels_all_index"
                      :label="labels"
                      >{{ labels }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <div class="m_tb_bottom" @click="handle_man_tag()">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.40076 3.27887C4.36778 3.34757 4.34088 3.42285 4.31942 3.5H5.18058C5.15912 3.42285 5.13222 3.34757 5.09924 3.27887C4.99692 3.06571 4.88735 3 4.75 3C4.61265 3 4.50308 3.06571 4.40076 3.27887ZM3.49924 2.84613C3.39697 3.05919 3.33296 3.28775 3.29545 3.5H2.25C1.97386 3.5 1.75 3.72386 1.75 4V9C1.75 9.14174 1.81016 9.27683 1.91552 9.37165L6.91552 13.8716C7.11318 14.0495 7.41551 14.0416 7.60355 13.8536L12.1036 9.35355C12.2988 9.15829 12.2988 8.84171 12.1036 8.64645L7.10355 3.64645C7.00979 3.55268 6.88261 3.5 6.75 3.5H6.20455C6.16704 3.28775 6.10303 3.05919 6.00076 2.84613C5.80308 2.43429 5.41265 2 4.75 2C4.08735 2 3.69692 2.43429 3.49924 2.84613ZM6.54289 4.5H6.22186C6.1901 4.79302 6.12824 5.11992 6.02044 5.41936C5.9653 5.57252 5.88699 5.74592 5.77866 5.90827C6.06885 6.1818 6.25 6.56974 6.25 7C6.25 7.82843 5.57843 8.5 4.75 8.5C3.92157 8.5 3.25 7.82843 3.25 7C3.25 6.17157 3.92157 5.5 4.75 5.5C4.80706 5.5 4.94233 5.46182 5.07956 5.08064C5.14406 4.90145 5.18758 4.69697 5.21449 4.5H3.75H2.75V8.77732L7.23188 12.811L11.0429 9L6.54289 4.5ZM4.75 6.5C4.47386 6.5 4.25 6.72386 4.25 7C4.25 7.27614 4.47386 7.5 4.75 7.5C5.02614 7.5 5.25 7.27614 5.25 7C5.25 6.72386 5.02614 6.5 4.75 6.5ZM9.10355 3.64645C8.90829 3.45118 8.59171 3.45118 8.39645 3.64645C8.20118 3.84171 8.20118 4.15829 8.39645 4.35355L13.0429 9L8.89645 13.1464C8.70118 13.3417 8.70118 13.6583 8.89645 13.8536C9.09171 14.0488 9.40829 14.0488 9.60355 13.8536L14.1036 9.35355C14.2988 9.15829 14.2988 8.84171 14.1036 8.64645L9.10355 3.64645Z"
                      fill="black"
                      fill-opacity="0.72"
                    />
                  </svg>

                  {{ lang.man_tag }}
                </div>
                <!-- <el-checkbox-group
                  class="flex_y"
                  trigger="hover"
                  v-model="item.labels"
                  @change="
                    (e) => {
                      add_tag(e, item);
                    }
                  "
                >
                  <el-checkbox
                    v-for="(labels, labels_all_index) in labels_all"
                    :key="labels_all_index"
                    :label="labels"
                    >{{ labels }}</el-checkbox
                  >
                </el-checkbox-group> -->
                <!-- <div
                  class="flex_x_item poin"
                  style="border-top: var(--border)"
                  @click="handle_man_tag()"
                >
                  <i class="iconfont cocoflow-biaoqian mr-5"></i>
                  {{ lang.man_tag }}
                </div> -->
              </div>
            </el-popover>
          </div>     
          <div class="ci_b_right">
            <div>
              <span class="cyD" v-if="item.cyid">
                {{ lang.community }}
              </span>
              <span class="havePublished" v-if="item.status == 1">{{
                lang.released
              }}</span>
              <span class="unpublish" v-else>{{ lang.unreleased }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pageLoading" v-if="pageLoading">
        <img src="@/assets/img/appCenter/loading.svg" alt="loading" />
        <span>
          {{ lang.Loading }}
        </span>
      </div>
    </div>
    <input
      type="file"
      name="file"
      id="file-input"
      accept=".json"
      style="width: 0; height: 0; opacity: 0"
      @change="change_input_import"
    />
    <addAppDialog
      v-if="addAppDialogFlag"
      :agentDate="agent_data"
    ></addAppDialog>
    <easyCreate ref="easyCreate"></easyCreate>
  </div>
</template>
<script>
import _ from 'lodash';
import createAppVue from './CreateApp.vue';
import ManTag from './ManTag.vue';
import Axios from 'axios';
import { Loading } from 'element-ui';
import addAppDialog from '@/components/agent/components/addAppDialog.vue';
import { Notification } from 'element-ui';
import easyCreate from './easyCreate';
import { myMixin } from '@/common/mixin.js';
import { isRestrictedOrg, getOrganizeIdFromUser } from '@/common/org.js';
import { USER_TYPE_CONSTANTS } from '@/common/constants.js';
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function (event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
export default {
  components: {
    createAppVue,
    ManTag,
    addAppDialog,
    easyCreate,
  },
  mixins: [myMixin],
  props: {
    active_type_tab: Number,
    search_input: String,
    filter_tag: String,
    statusOptionsValue: String,
    tagOptionsValueList: Array,
    checkAll: Boolean,
    selectType: Number,
    modeType: {
      type: String,
      default: ''
    },
    checkMode: {
      type: String,
      default: '0'
    }
  },
  directives: {
    'click-outside': clickOutside, // 注册自定义指令
  },
  data() {
    return {
      communityList:[],
      loadingInstance: null,
      labels_all: [],
      labelsList: [],
      loading: false,
      pageLoading: false,
      AgentList: [],
      total: 0,
      pageNum: 1,
      createAppFlag: false,
      ManTagFlag: false,
      edit_item_data: {},
      agent_data: {},
      timeout: null,
      editAppCard: null,
      addAppDialogFlag: false,
      is_current_change: true,
      tagSearchValue: '',
      USER_TYPE_CONSTANTS: USER_TYPE_CONSTANTS
    };
  },
  computed: {
    // 社区名称 
    cyname() {
      return (id) => {
        if (!id) return ''
        try {
          let kk = this.communityList.filter(e=> e.id == id)
          return kk[0].name;
        } catch (error) {
          return ''
        }
        
      };
    },
    shouldHideAgentShortcuts() {
      return isRestrictedOrg(getOrganizeIdFromUser(this.user));
    },
    tagCom() {
      return function (row) {
        return row.join('，');
      };
    },
    labels_allFilter() {
      // 正则获取列表
      const reg = new RegExp(this.tagSearchValue, 'i');
      return this.labels_all.filter((item) => reg.test(item));
    },
  },
  watch: {
    // '$store.state.global_loading'(newValue) {
    //   if (newValue) {
    //     this.loadingInstance = Loading.service({
    //       text: this.lang.Loading,
    //     });
    //   } else {
    //     this.$nextTick(() => {
    //       this.loadingInstance.close();
    //     });
    //   }
    // },
    active_type_tab(newValue) {
      this.pageNum = 1;
      this.AgentList = [];
      this.is_current_change = true;
      this.get_data(newValue);
    },
    selectType(newValue) {
      console.log('====>', newValue);
      this.pageNum = 1;
      this.AgentList = [];
      this.is_current_change = true;
      this.get_data(newValue);
    },
    // search_input() {
    // if (!this.timeout) {
    // 	this.pageNum = 1;
    // 	this.AgentList = [];
    // 	this.is_current_change = true;
    // 	this.get_data(this.active_type_tab);
    // 	this.timeout = setTimeout(() => {
    // 		this.timeout = null;
    // 	}, 1000);
    // }
    // },
    filter_tag() {
      this.pageNum = 1;
      this.AgentList = [];
      this.is_current_change = true;
      this.get_data(this.selectType);
    },
    statusOptionsValue() {
      this.pageNum = 1;
      this.AgentList = [];
      this.is_current_change = true;
      this.get_data(this.selectType);
    },
    loading(newValue) {
      this.$parent.agentListLoading = newValue;
    },
    checkMode(newValue) {
      console.log('checkMode', newValue);
      if(newValue == 1 || newValue == 2 || newValue == 3){
        this.edit_item_data = {};
        this.createAppFlag = true
      }
    }
  },
  activated(){
    this.changeTagList()
  },
  mounted() {
    this.pageNum = 1;
    this.getcommunity()
    this.get_data(this.selectType);
    this.bus.$on('line_agent', (data) => {
      this.line_agent(data);
    });

    document.body.style.overflowY = 'hidden';
    console.log('checkMode', this.checkMode);
    if(this.checkMode == 1 || this.checkMode == 2 || this.checkMode == 3){
      this.edit_item_data = {};
      this.createAppFlag = true
    }
  },
  beforeDestroy() {
    document.body.style.overflowY = 'auto';
  },
  methods: {
    // 获取社区信息
    getcommunity(){
      let params = {
        org: this.user.org, //用户ID
        oid: this.user.organizeid, //用户ID
      };
      // console.log('params',params);
      this.ajax
        .get(this.$store.state.api + "getCococy", params)
        .then((res) => {
          console.log(res);
          this.communityList = res.data[0]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleScroll: _.throttle(function (event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      // 触底条件
      //console.log(Math.abs(scrollHeight - scrollTop - clientHeight) < 1)
      if (
        Math.abs(scrollHeight - scrollTop - clientHeight) < 1 &&
        !this.loading &&
        this.is_current_change
      ) {
        this.current_change();
      }
    }, 500),
    changeTagList() {
      this.pageNum = 1;
      this.AgentList = [];
      this.is_current_change = true;
      this.get_data(this.selectType);
    },
    changeSearchValue() {
      if (!this.timeout) {
        this.pageNum = 1;
        this.AgentList = [];
        this.is_current_change = true;
        this.get_data(this.selectType);
        this.timeout = setTimeout(() => {
          this.timeout = null;
        }, 1000);
      }
    },
    add_tag(tag, agent) {
      let old = agent.labels2;
      let newtages = tag.filter((t) => !old.includes(t));
      let removedTags = old.filter((t) => !tag.includes(t));
      console.log(tag, agent);

      const tag_id = this.labelsList.find(
        (item) => item.name === newtages.at(-1)
      )?.id;
      const removedTags_id = this.labelsList.find(
        (item) => item.name === removedTags.at(-1)
      )?.id;

      try {
        if (tag_id) {
          Axios.post(
            this.new_url + '/api/agentLabels',
            {
              agent_id: agent.id,
              label_id: tag_id,
            },
            {
              headers: { 'Content-Type': 'application/json' },
            }
          );
        }
        if (removedTags_id) {
          Axios.delete(this.new_url + '/api/agentLabels/cancel', {
            data: {
              agent_id: agent.id,
              label_id: removedTags_id,
            },
            headers: { 'Content-Type': 'application/json' },
          });
        }
        agent.labels2 = JSON.parse(JSON.stringify(agent.labels));
      } catch (error) {
        console.log(error);
      }
    },
    handle_man_tag() {
      this.ManTagFlag = true;
    },
    current_change() {
      this.pageNum++;
      this.get_data(this.selectType);
    },
    get_data: _.debounce(function(tab) {
      // tab = 0;
      let label_names = '';
      // if (this.filter_tag == this.lang.all) {
      // 	label_names = "";
      // } else {
      // 	label_names = this.filter_tag;
      // }
      // console.log(this.tagOptionsValueList,this.checkAll)

      // let label_namesString = this.tagOptionsValueList.join("&&label_names=");

      if (this.checkAll || this.tagOptionsValueList.length == 0) {
        label_names = '';
      } else {
        label_names = this.tagOptionsValueList.join('&&label_names=');
      }

      if (this.filter_tag == this.lang.all) {
        label_names = '';
      }

      let pageSize = 30;
      switch (tab) {
        case 0:
          this.get_all(
            `/api/agents/all?agentName=${this.search_input}&&label_names=${label_names}&&status=${this.statusOptionsValue}&&userId=${this.user.userId}&&pageNum=${this.pageNum}&&pageSize=${pageSize}`
          );
          break;
        case 1:
          this.get_all(
            `/api/agents/agent?agentName=${this.search_input}&&label_names=${label_names}&&status=${this.statusOptionsValue}&&userId=${this.user.userId}&&pageNum=${this.pageNum}&&pageSize=${pageSize}`
          );
          break;
        case 2:
          this.get_all(
            `/api/agents/muti_agent?agentName=${this.search_input}&&label_names=${label_names}&&status=${this.statusOptionsValue}&&userId=${this.user.userId}&&pageNum=${this.pageNum}&&pageSize=${pageSize}`
          );
          break;
        case 3:
          this.get_all(
            `/api/agents/ai_edit?agentName=${this.search_input}&&label_names=${label_names}&&status=${this.statusOptionsValue}&&userId=${this.user.userId}&&pageNum=${this.pageNum}&&pageSize=${pageSize}`
          );
          break;
        default:
          break;
      }
    }, 300),
    get_all(url) {
      if (this.pageNum > 1) {
        this.pageLoading = true;
      } else {
        this.loading = true;
      }
      const my_role_config = {
        method: 'get',
        url: this.new_url + url,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      Axios(my_role_config)
        .then((res) => {
          try {
            const agentData = res.data.data;
            agentData.forEach((item, index) => {
              agentData[index].hover = false;
              agentData[index].labels = item.labels.map((labels) => {
                //console.log(labels)
                return labels.name;
              });
            });
            this.AgentList = this.AgentList.concat(agentData);
            this.total = res.data.total;
            this.pageLoading = false;
            this.loading = false;
            if (agentData.length < 30) {
              this.is_current_change = false;
            }
          } catch (err) {
            this.is_current_change = false;
            console.log('无数据', err);
            this.loading = false;
            this.pageLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          // this.$message.error('服务器繁忙');
        });
      if (this.pageNum == 1) this.get_lable();
    },
    get_lable() {
      const lable_config = {
        method: 'get',
        url: this.new_url + '/api/labels?userId=' + this.user.userId,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      Axios(lable_config)
        .then((res) => {
          this.labelsList = res.data;
          this.$emit('get_tagOptions', this.labelsList);
          this.labels_all = res.data.map((item) => {
            return item.name;
          });
        })
        .catch((error) => {
          // this.$message.error('服务器繁忙');
          //this.$message.error("获取标签数据失败，请联系后端技术员！");
          console.log(error);
        });
    },
    omit(obj, ...keys) {
      const shallowCopy = { ...obj };
      keys.forEach((key) => delete shallowCopy[key]);
      return shallowCopy;
    },
    StopUP() {
      console.log('555');
    },
    edit_item(item) {
      this.createAppFlag = true;
      this.edit_item_data = item;
    },
    add_muti_agent(item) {
      const loadingInstance = Loading.service({
        text: this.lang.get_data_in,
      });
      const config = {
        method: 'post',
        url: this.GLOBAL.Base_Url + 'get_agent_park_chat',
        headers: {
          'Content-Type': 'application/json',
          hwMac: this.user.organizeid,
        },
        data: {
          userid: this.user.userId,
          groupid: item.id,
          session_name: this.user.userId,
        },
      };
      Axios(config)
        .then((res) => {
          try {
            const data = JSON.parse(res.data.FunctionResponse);
            item.content = data.content[0].content;
            const add_config = {
              method: 'post',
              url: this.GLOBAL.Base_Url + 'insert_muti_agent',
              headers: {
                'Content-Type': 'application/json',
                hwMac: this.user.organizeid,
              },
              data: {
                userId: this.user.userId,
                userName: this.user.userName,
                organizeid: this.user.organizeid,
                name: item.muti_name + '_copy',
                description: item.description,
                isPublish: 0,
                content: item.content,
              },
            };
            Axios(add_config)
              .then(() => {
                this.$nextTick(() => {
                  loadingInstance.close();
                });
                this.$message.success(this.lang.fzcg);
                this.get_muti_agent();
              })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    delete_item(item, index) {
      this.$confirm(this.lang.delete_tip, this.lang.tip, {
        confirmButtonText: this.lang.queding,
        cancelButtonText: this.lang.cancel,
        type: 'warning',
      })
        .then(() => {
          if (item.source == 'agent') {
            this.delete_agent(item, index);
          } else if(item.source == 'mutiagent'){
            this.delete_muti_agent(item, index);
          }else if(item.source == 'aiedit'){
            this.delete_ai_web(item, index);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: 'info',
            message: this.lang.canceled,
          });
        });
    },
    delete_agent(item, index) {
      this.AgentList.splice(index, 1);
      const config = {
        method: 'delete',
        url: this.new_url + '/api/agents/agent/' + item.id,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      Axios(config)
        .then((res) => {
          if (res.status == 200){ 
            this.$message.success(this.lang.delete_cg)
						this.addOp3(1, "", {id: item.id, name: item.assistantName, type: 'delete_agent'}, "success")
          }
        })
        .catch(function (error) {
						this.addOp3(1, "", {id: item.id, name: item.assistantName, type: 'delete_agent'}, error)
            console.log(error);
        });
    },
    delete_muti_agent(item, index) {
      this.AgentList.splice(index, 1);
      const muti_config = {
        method: 'delete',
        url: this.new_url + '/api/agents/muti_agent/' + item.id,
        headers: {
          'Content-Type': 'application/json',
        },
        // data: {
        //   agent_id: item.id,
        // },
      };
      Axios(muti_config)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.lang.delete_cg,
          });
          this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'delete_muti_agent'}, "success")
        })
        .catch((error) => {
						this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'delete_muti_agent'}, error)
            console.log(error);
        });
    },
    delete_ai_web(item, index) {
      this.AgentList.splice(index, 1);
      const muti_config = {
        method: 'delete',
        url: this.new_url + '/api/agents/ai_edit/' + item.id,
        headers: {
          'Content-Type': 'application/json',
        },
        // data: {
        //   agent_id: item.id,
        // },
      };
      Axios(muti_config)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.lang.delete_cg,
          });
          this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'delete_ai_web'}, "success")
        })
        .catch((error) => {
						this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'delete_ai_web'}, error)
            console.log(error);
        });
    },
    line_agent(item) {
      if(!item.isEditable){
        this.$message.warning("本应用为从模板创建，不支持二次修改");
        return;
      }
      if (item.source == 'agent' || !item?.source) {
        this.$router.push({
          path: '/AgentPage',
          query: { id: item.id, create: false },
        });
      } else if(item.source == 'mutiagent'){
        this.$router.push({
          path: '/workFlow',
          query: { id: item.id, create: false },
        });
      }else if(item.source == 'aiedit'){
        this.$router.push({
          path: '/web',
          query: { id: item.id, create: false },
        });
      }
    },
    publish(item) {
      this.agent_data = item;
      this.addAppDialogFlag = true;
    },
    unpublish(item) {
      if (this.active_type_tab == 1) {
        this.$axios
          .post(this.new_url + '/api/agents/publishAgent/' + item.id, {
            status: 0,
          })
          .then((res) => {
            if (res.status == 200) {
              this.$message.success(this.lang.canceled);
            }
          });
      } else if (this.active_type_tab == 2) {
        this.$axios
          .post(this.new_url + '/api/agents/publishMutiAgent/' + item.id, {
            status: 0,
            modes: ['0', '1', '2'],
          })
          .then((res) => {
            if (res.status == 200) {
              this.$message.success(this.lang.canceled);
            }
          });
      }
    },
    unpublish2(item){
      if(item.source=='mutiagent'){//工作流
        let params = {
          status: 0,
          modes: ['0', '1', '2'],
        };
        this.ajax
          .post(
            `https://appapi.cocorobo.cn/api/agents/cancelPublishMutiAgent/${item.id}`,
            params
          )
          .then((res) => {
            let _msg = res.data.message;
            if (_msg == "MutiAgent unpublished successfully") {
              this.$message.success(this.lang.canceled);
              this.AgentList.find((e)=>{
                if(e.id==item.id){
                  e.status=0
                }
              })
            } else {
              this.$message.error(this.lang.unpublishFailure)
            }
          })
          .catch(() => {
            this.$message.error(this.lang.unpublishFailure)
          });
      }else if(item.source=='agent'){//智能体
        let params = {
          status: 0,
          modes: ['0'],
        };
        this.ajax
            .post(
              `https://appapi.cocorobo.cn/api/agents/cancelPublishAgent/${item.id}`,
              params
            )
            .then((res) => {
              let _msg = res.data.message;
              if (_msg == "Agent unpublished successfully") {
                this.$message.success(this.lang.canceled);
                this.AgentList.find((e)=>{
                if(e.id==item.id){
                  e.status=0
                }
              })
              } else {
                this.$message.error(this.lang.unpublishFailure)
              }
            })
            .catch(() => {
              this.$message.error(this.lang.unpublishFailure)
            });
        }
      
    },
    createApp() {
      this.edit_item_data = {};
      this.createAppFlag = true;
    },
    change_create_app_flag(value) {
      this.createAppFlag = value.flag;
      if (value.id) {
        const index = this.AgentList.findIndex((item) => item.id === value.id);
        this.$set(this.AgentList[index], 'name', value.data.app_name);
        this.$set(this.AgentList[index], 'description', value.data.app_desc);
        this.$set(this.AgentList[index], 'headUrl', value.data.app_image);
      }
    },
    change_man_tag_flag(value) {
      this.ManTagFlag = value;
    },
    createAppModel() {
      this.$refs.easyCreate.open();
      // this.$message.info(this.lang.undevelopedFunction)
    },
    file_import() {
      // 首先获取到上传的文件输入框元素
      const fileInput = document.getElementById('file-input');
      fileInput.click();
    },
    change_input_import(event) {
      //this.loading = true;
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      this.addOp3(1, "", { type: 'import_from_file'}, "success", 1)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.importworkflows(e.target.result,true,()=>{
			this.pageNum = 1;
            this.AgentList = [];
            this.get_data(this.selectType);
				document.getElementById('file-input').value = '';
		})
				// try {
        //   const json = JSON.parse(e.target.result);

        //   let _timer = null;
        //   let _percentageValue = 0;
        //   let _step = 0;
        //   let _maxStep = 10;
        //   // let _dian = 1;

        //   let _notify = this.$notify({
        //     title: this.lang.import,
        //     dangerouslyUseHTMLString: true,
        //     message: `<p style="margin-bottom:5px">${json.muti_name}</p><div style="display:flex"><span style="display:block;width:95px">${this.lang.beingImported}......</span> ${_percentageValue}%</div>`,
        //     position: 'bottom-right',
        //     duration: 0,
        //   });
        //   _timer = setInterval(() => {
        //     if (_percentageValue <= 20 && _step > _maxStep) {
        //       _percentageValue += 6;
        //       _step = 0;
        //     } else if (_percentageValue <= 40 && _step > _maxStep) {
        //       _percentageValue += 4;
        //       _step = 0;
        //     } else if (_percentageValue <= 60 && _step > _maxStep) {
        //       _percentageValue += 2;
        //       _step = 0;
        //     } else if (_percentageValue <= 80 && _step > _maxStep) {
        //       _percentageValue += 2;
        //       _step = 0;
        //     } else if (_percentageValue <= 99 && _step > _maxStep) {
        //       _percentageValue = 99;
        //       _step = 0;
        //     }
        //     _step++;
        //     // if(_dian>=6){
        //     // 	_dian = 1;
        //     // }else{
        //     // 	_dian++;
        //     // }
        //     _notify.dom
        //       .querySelector('.el-notification__content')
        //       .querySelector(
        //         'div'
        //       ).innerHTML = `<span style="display:block;width:100%">${this.lang.beingImported}......</span>${_percentageValue}%`;
        //   }, 100);

        //   this.$axios
        //     .post(this.new_url + '/api/agents/import_mutiAgent', {
        //       userid: this.user.userId,
        //       username: this.user.userName,
        //       muti_name: json.muti_name,
        //       description: json.description,
        //       headUrl: json.headUrl,
        //       isPublish: 0,
        //       organizeid: this.user.organizeid,
        //       content: JSON.stringify(json.content),
        //     })
        //     .then(() => {
        //       if (_timer) {
        //         clearInterval(_timer);
        //         _timer = null;
        //         _notify.dom
        //           .querySelector('.el-notification__content')
        //           .querySelector(
        //             'div'
        //           ).innerText = `${this.lang.beingImported}...... 100%`;
        //         setTimeout(() => {
        //           _notify.close();
        //         }, 200);
        //       }
        //       this.pageNum = 1;
        //       this.AgentList = [];
        //       this.get_data(this.selectType);
        //     })
        //     .catch((err) => {
        //       // this.$message.error('服务器繁忙');
        //       console.log(err);
        //       if (_timer) {
        //         clearInterval(_timer);
        //         _timer = null;
        //         setTimeout(() => {
        //           _notify.close();
        //         }, 200);
        //       }
        //     });
        // } catch (error) {
        //   console.error('Error parsing JSON file:', error);
        // }
      };
      reader.readAsText(file);
    },
    handle_agent_dian(index) {
      this.AgentList[index].popover = true;
    },
    copy_item(item) {
      this.addOp3(1, "", { id: item.id, type: 'duplicate_project'}, "success", 1)
      if (item.assistantName || item.source == 'agent') {
        this.copy_agent(item);
        // this.$parent.addOp2(item.id, item.name, 'agentlist_copy_agent')
      } else if(item.source == 'mutiagent'){
        this.copy_muti_agent(item);
        // this.$parent.addOp2(item.id, item.name, 'agentlist_copy_muti_agent')
      }else if(item.source == 'aiedit'){
        this.copy_ai_web(item);
        // this.$parent.addOp2(item.id, item.name, 'agentlist_copy_ai_web')
      }
    },
    copy_muti_agent(item) {
      Notification({
        title: this.lang.copying,
        message: item.name,
        position: 'bottom-right',
        duration: 0,
      });
      let config = {
        method: 'post',
        url: this.new_url + '/api/agents/copy_mutiAgent',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          ids: [item.id],
          userId: this.user.userId,
          username: this.user.userName,
        },
        timeout: 0,
      };
      this.$axios(config)
        .then((res) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_copy_muti_agent' },
            'success'
          );
          console.log(res.data);
          this.$message.success(this.lang.succeed);
          Notification.closeAll();
          this.pageNum = 1;
          this.AgentList = [];
          this.get_data(this.selectType);
        })
        .catch((error) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_copy_muti_agent' },
            error
          );
          Notification.closeAll();
          this.loading = false;
          // this.$message.error('服务器繁忙');
        });
    },
    copy_ai_web(item) {
      Notification({
        title: this.lang.copying,
        message: item.name,
        position: 'bottom-right',
        duration: 0,
      });
      let config = {
        method: 'post',
        url: this.new_url + '/api/agents/copy_aiEdit',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          ids: [item.id],
          userId: this.user.userId,
          username: this.user.userName,
        },
        timeout: 0,
      };
      this.$axios(config)
        .then((res) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_copy_ai_web' },
            'success'
          );
          console.log(res.data);
          this.$message.success(this.lang.succeed);
          Notification.closeAll();
          this.pageNum = 1;
          this.AgentList = [];
          this.get_data(this.selectType);
        })
        .catch((error) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_copy_ai_web' },
            error
          );
          Notification.closeAll();
          this.loading = false;
          // this.$message.error('服务器繁忙');
        });
    },
    copy_agent(export_copy_agent) {
      // const loadingInstance = Loading.service({
      //   text: this.lang.copying,
      // });
      Notification({
        title: this.lang.copying,
        message: export_copy_agent.name,
        position: 'bottom-right',
        duration: 0,
      });
      let config = {
        method: 'post',
        url: this.new_url + '/api/agents/copy_agent',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          ids: [export_copy_agent.id],
          userId: this.user.userId,
          username: this.user.userName,
        },
        timeout: 0,
      };
      this.$axios(config)
        .then((res) => {
          this.addOp3(
            1,
            '',
            {
              id: export_copy_agent.id,
              name: export_copy_agent.name,
              type: 'agentlist_copy_agent',
            },
            'success'
          );
          this.$message.success(this.lang.succeed);
          Notification.closeAll();
          // this.$nextTick(() => {
          //   loadingInstance.close();
          // });
          this.AgentList.unshift(res.data[0]);
        })
        .catch((error) => {
          this.addOp3(
            1,
            '',
            {
              id: export_copy_agent.id,
              name: export_copy_agent.name,
              type: 'agentlist_copy_agent',
            },
            error
          );
          Notification.closeAll();
          // this.$message.error('服务器繁忙');
          // this.$nextTick(() => {
          //   // 以服务的方式调用的 Loading 需要异步关闭
          //   loadingInstance.close();
          // });
        });
    },
    handle_collect(item) {
      if (item.isCollect) {
        this.cancel_collect(item);
        // this.$parent.addOp2(item.id, item.name, 'agentlist_collect_cancel')
      } else {
        this.collect(item);
        // this.$parent.addOp2(item.id, item.name, 'agentlist_collect')
      }
    },
    cancel_collect(item) {
      const config = {
        method: 'delete',
        url: this.new_url + '/api/collects/cancel',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userId: this.user.userId,
          agent_id: item.id,
        },
      };
      this.$axios(config)
        .then(() => {
          const index = this.AgentList.findIndex((AgentList) => {
            return AgentList.id == item.id;
          });
          this.$set(this.AgentList[index], 'isCollect', 0);
          this.$set(this.AgentList[index], 'popover', false);
          this.bus.$emit('cancel_collect', item.id);
          this.$message.success(this.lang.succeed);
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_collect_cancel' },
            'success'
          );
        })
        .catch((error) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_collect_cancel' },
            error
          );
          console.log(error);
          // this.$message.error('服务器繁忙');
        });
    },
    collect(item) {
      const config = {
        method: 'post',
        url: this.new_url + '/api/collects',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userId: this.user.userId,
          agent_id: item.id,
        },
      };
      this.$axios(config)
        .then((res) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_collect' },
            'success'
          );
          console.log(res);
          const index = this.AgentList.findIndex((AgentList) => {
            return AgentList.id == item.id;
          });
          this.$set(this.AgentList[index], 'isCollect', 1);
          this.$set(this.AgentList[index], 'popover', false);
          this.bus.$emit('collect', this.AgentList[index]);
          this.$message.success(this.lang.succeed);
        })
        .catch((error) => {
          this.addOp3(
            1,
            '',
            { id: item.id, name: item.name, type: 'agentlist_collect' },
            error
          );
          console.log(error);
          // this.$message.error('服务器繁忙');
          //this.$message.success(this.lang.data_failure);
        });
    },
    updateCard(id) {
      if (this.editAppCard == id) return (this.editAppCard = null);
      this.editAppCard = id;
    },
    handleBlur() {
      this.editAppCard = null;
    },
    selectTagBox() {
      console.log(this.tagSearchValue);
    },
    viewCard(item) {
      let url = '';
      if (item.status === 0) {
        //未发布的
        if (item.source === 'mutiagent') {
          //工作流默认跳转卡片上
          switch (this.domain_name) {
            case 'cn':
              if (window.location.href.includes('beta')) {
                url =
                  'https://beta.knowledge.cocorobo.cn/zh-CN/run-agent-flow/';
              } else {
                url = 'https://knowledge.cocorobo.cn/zh-CN/run-agent-flow/';
              }
              break;
            case 'hk':
              url = 'https://knowledge.cocorobo.hk/zh-HK/run-agent-flow/';
              break;
            case 'com':
              url = 'https://knowledge.cocorobo.com/en-US/run-agent-flow/';
              break;
            default:
              url = 'https://knowledge.cocorobo.com/en-US/story-telling/';
              break;
          }
          url = url + item.id + '?preview=1';
        } else if (item.source === 'agent') {
          //智能体默认跳转聊天式
          switch (this.domain_name) {
            case 'cn':
              if (window.location.href.includes('beta')) {
                url = 'https://aichat.cocorobo.cn/?id=';
              } else {
                url = 'https://aichat.cocorobo.cn/?id=';
                //url = "http://localhost:8080/aigpt/#/dialogMode?id=";
              }
              break;
            case 'hk':
              url = 'https://aichat.cocorobo.hk/#/?id=';
              break;
            case 'com':
              url = 'https://aichat.cocorobo.com/#/?id=';
              break;
            default:
              url = 'https://aichat.cocorobo.cn/?id=';
              break;
          }
          url = url + item.id + '&type=agent&preview=true';
        }
        window.open(url, '_blank');
      } else if (item.status === 1) {
        //跳转至最后发布的页面
        this.ajax
          .get('https://appapi.cocorobo.cn/api/agents/get_app_id', {
            id: item.id,
          })
          .then((res) => {
            let _data = res.data;
            if (_data.id) {
              this.ajax
                .get(this.$store.state.api + 'select_appStoreById', {
                  uid: this.user.userId,
                  aid: _data.id,
                })
                .then((res2) => {
                  let _data2 = res2.data[0];
                  if (_data2.length > 0) {
                    window.open(_data2[0].url, '_blank');
                  } else {
                    item.status = 0;
                    this.viewCard(item);
                  }
                })
                .catch((e2) => {
                  console.log(e2);
                  item.status = 0;
                  this.viewCard(item);
                });
            }
          })
          .catch((e) => {
            console.log(e);
            item.status = 0;
            this.viewCard(item);
            // this.releaseData = null;
          });
      }
    },
  },
};
</script>
<style scoped>
/* .agent-bottom {
  position: absolute;
  bottom: 5px;
  left: 0;
}
.grid4 {
  display: grid;
  justify-content: space-around;
  grid-template-columns: 23% 23% 23% 23%;
  grid-gap: 10px;
  padding: 10px;
} */
.AgentList {
  position: relative;
  width: 100%;
  /* height: auto; */
  height: calc(100vh - 115px);
  overflow-y: hidden;
  /* overflow-y: auto; */
  /* position: relative; */
  /* transform: rotate(0); */
}
.pagination {
  width: 100%;
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: center;
  left: 0;
  /* left: calc(50vw - 50%); */
  /* background-color: red; */
}

.showItemBox {
  width: 100%;
  height: 100%;
  /* min-height: 500px; */
  /* display: flex; */
  /* flex-wrap: wrap; */
  box-sizing: border-box;
  padding: 0 7px 0 20px;
  overflow-y: auto;
}
.agent-item {
  /* position: relative; */
  width: calc(100% / 4 - 15px * 3 / 3);
	min-width: 285px;
  /* height: 195px; */
  height: 215px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* height: 240px; */
  /* height: 14vh; */
  background: #fff;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 15px;
  box-shadow: 2px 3px 4px #eaeaea;
  float: left;
  transition: 0.2s;
  /* padding: 8px; */
  /* text-align: start; */
  /* overflow: hidden; */
}

.agent-item:hover {
  box-shadow: 0px 6px 30px 5px #00000015;
}

/* @media screen and (min-width: 1400px) {
	.agent-item {
		width: calc(100% / 4 - (15px * 3) / 3) !important;
	}
}

@media screen and (max-width: 1380px) {
	.agent-item {
		width: calc(100% / 4 - (15px * 3) / 3) !important;
	}

	.agent-item:nth-child(4n) {
		margin-right: 0px !important;
	}
}

@media screen and (max-width: 1080px) {
	.agent-item {
		width: calc(100% / 3 - (15px * 3) / 3) !important;
	}

	.agent-item:nth-child(5n) {
		margin-right: 15px !important;
	}

	.agent-item:nth-of-type(4n) {
		margin-right: 15px !important;
	}

	.agent-item:nth-child(3n) {
		margin-right: 0 !important;
	}
}
.create-app {
	background: #ede9e9;
} */

@media screen and (min-width: 2821px) {
  .agent-item {
    width: calc(100% / 7 - (15px * 6) / 7) !important;
  }
  .agent-item:nth-child(7n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2820px) and (min-width: 2476px) {
  .agent-item {
    width: calc(100% / 6 - (15px * 5) / 6) !important;
  }
  .agent-item:nth-child(6n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2475px) and (min-width: 2094px) {
  .agent-item {
    width: calc(100% / 5 - (15px * 4) / 5) !important;
  }
  .agent-item:nth-child(5n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 2093px) and (min-width: 1421px) {
  .agent-item {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }
  .agent-item:nth-child(4n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 1420px) and (min-width: 1121px){
  /*and (min-width: 1201px)*/
  .agent-item {
    width: calc(100% / 3 - (15px * 2) / 3) !important;
  }
  .agent-item:nth-child(3n) {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 1120px) {
	.agent-item {
		width: calc(100% / 2 - 15px / 2) !important;
	}
	.agent-item:nth-child(2n) {
		margin-right: 0px !important;
	}
}

.addAppBox {
  background: none !important;
  box-shadow: none !important;
  display: flex;
}

.addAppBox > div {
  box-shadow: 2px 3px 4px #eaeaea;
  transition: 0.2s;
  height: 100%;
  flex: 1;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
  box-sizing: border-box;
  padding: 10px 10px 65px;
  display: flex;
  flex-direction: column;
}

.addAppBox > div > h3 {
  font-size: 16px;
  /* min-height: 2em; */
}

.addAppBox > div > span {
  color: #00000066;
  margin: 8px 0px 15px 0;
  display: block;
  font-size: 12px;
  height: fit-content;
}

.addAppBox > div > div {
  width: fit-content;
	/* white-space: nowrap; */
	padding: 0 10px;
  height: fit-content;
  background: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
	position: relative;
	z-index: 2;
}

.addAppBox > div > img {
  width: 70%;
  height: auto;
  position: absolute;
  right: 50%;
  top: 100%;
  max-width: 64px;
  max-height: 64px;
  transform: translate(80%, -100%);
  z-index: 1;
}

.addAppBox > div:hover {
  box-shadow: 0px 6px 10px 5px #00000015;
}

.aab_type1 {
  background: linear-gradient(179.26deg, #f0f5ff 0.09%, #d8e6ff 99.96%);
}

.aab_type1 > h3 {
  color: rgba(3, 84, 215);
}

.aab_type1 > div {
  color: rgba(3, 84, 215);
}

.aab_type2 {
  margin: 0 10px;
  background: linear-gradient(179.57deg, #f4f5fe 0.05%, #eae9fd 99.96%);
}

.aab_type2 > h3 {
  color: rgba(120, 3, 215);
}

.aab_type2 > div {
  color: rgba(120, 3, 215);
}

.aab_type3 {
  background: linear-gradient(237.76deg, #f0f9fc 3.41%, #e4f3fc 90.23%);
}
.aab_type3 > h3 {
  color: rgba(18, 141, 166);
}
.aab_type1 > span {
  flex: 1;
}
.aab_type2 > span {
  flex: 1;
}
.aab_type3 > span {
  flex: 1;
}
.aab_type3 > div {
  color: rgba(18, 141, 166);
}

/*
.addAppBox {
	background: none !important;
	box-shadow: none !important;
	display: flex;
	flex-direction: column;
}

.addAppBox > div > div {
	box-shadow: 2px 3px 4px #eaeaea;
	transition: 0.2s;
}

.addAppBox > div > div:hover {
	box-shadow: 0px 6px 10px 5px #00000015;
}

.aab_top {
	width: 100%;
	flex: 1;
	margin-bottom: 8px;
}

.aab_top > div {
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	padding: 10px;
	// border: 1px solid #FFFFFF;
	background: linear-gradient(
		69.14deg,
		#e5eefe 2.21%,
		#bad0f8 47.15%,
		#e5eefe 92.08%
	);
	border-radius: 5px;
	cursor: pointer;
	position: relative;
}

.aab_bottom {
	width: 100%;
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0;
}
.abb_b_left {
	margin-right: 10px;
	background: linear-gradient(221.31deg, #f4f5fe 2.6%, #eae9fd 76.61%);
}

.abb_b_right {
	background: linear-gradient(237.76deg, #f0f9fc 3.41%, #e4f3fc 90.23%);
}

.aab_bottom > div {
	height: 100%;
	flex: 1;
	box-sizing: border-box;
	padding: 10px;
	// border: 1px solid #FFFFFF;
	border-radius: 8px;
	cursor: pointer;
}

.aab_title {
	font-size: 16px;
	font-weight: 600;
}

.aab_top > div > .aab_title {
	color: #003b99 !important;
}

.abb_b_left > .aab_title {
	color: #5a01a3 !important;
}

.abb_b_right > .aab_title {
	color: #0e687a !important;
}

.aab_brief {
	font-size: 12px;
	color: #00000066;
	margin: 7px 0;
}

.aab_top > div > .aab_btn {
	color: #003b99 !important;
	background-color: #e6effe !important;
}

.abb_b_left > .aab_btn {
	color: #5a01a3 !important;
	background-color: #f3f2fe !important;
}

.abb_b_right > .aab_btn {
	color: #0e687a !important;
	background-color: #f1f8fd !important;
}

.aab_btn {
	background-color: white;
	font-size: 12px;
	border-radius: 100px;
	display: block;
	width: 70px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	border: solid 1px #fff;
}
*/

.disable {
  cursor: not-allowed; /* 改变鼠标样式为禁止 */
  pointer-events: none; /* 禁用鼠标事件 */
  opacity: 0.5; /* 可选，使元素看起来更“禁用” */
  background-color: #f0f0f0; /* 可选，改变背景颜色 */
}
.aab_i_b_btn {
  box-sizing: border-box;
  padding: 20px 15px;
  overflow: hidden;
  cursor: pointer;
}

.addAppIcon {
  height: 80%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
}

.addAppbg {
  width: 35%;
  height: 35%;
  position: absolute;
  right: 0;
}

.aab_i_b_btn > div {
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.aab_i_b_btn > span {
  font-size: 14px;
  color: #00000066;
  margin-top: 5px;
  display: block;
}

.cardItem_top {
  width: 100%;
  height: 145px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px 20px 0 20px;
  /* background-color: red; */
}

.ci_t_top {
  width: 100%;
  height: 62px;
  display: flex;
}

.ci_t_t_left {
  width: 62px;
  height: 62px;
  border-radius: 2px;
  overflow: hidden;
}

.ci_t_t_left > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ci_t_t_right {
  width: calc(100% - 62px - 10px);
  height: 62px;
  margin-left: 10px;
}

.ci_t_t_r_top {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
}

.ci_t_t_r_top > span {
  font-size: 18px;
  font-weight: 600;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ci_t_t_r_top > div {
  width: 58px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ci_t_t_r_bottom {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ci_t_t_r_bottom > span {
  color: #00000066;
  max-width: calc(100% - 75px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 25px;
}

.ci_t_t_r_bottom > div {
  /* width: 75px; */
  height: 25.5px;
  display: flex;
  padding: 0 5px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: #f3f3f3;
  color: #00000066;
  border-radius: 3px;
}

.ci_t_t_r_bottom > div > img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.ci_t_bottom {
  box-sizing: border-box;
  padding: 10px 0;
}

.ci_t_left {
  width: 64px;
  height: 100%;
}

.ci_t_left > div {
  width: 64px;
  height: 64px;
  border-radius: 2px;
  box-sizing: border-box;
  border: 1px solid #e7e7e7;
}

.ci_t_left > div > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ci_t_right {
  width: calc(100% - 74px);
  margin-left: 10px;
  height: 100%;
}

.ci_t_r_message {
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding-bottom: 3px;
}

.ci_t_r_message > div:nth-child(1) {
  display: flex;
  justify-content: space-between;
}

.ci_t_r_message > div:nth-child(1) > span {
  display: block;
  max-width: calc(100% - 60px);
  height: 30px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  line-height: 30px;
}

.ci_t_r_message > div:nth-child(1) > div {
  width: 50px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* background-color: red; */
}

.ci_t_r_message > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
}

.ci_t_r_message > div:nth-child(2) > div {
  width: 75px;
  height: 25.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: #f3f3f3;
  color: #00000066;
  border-radius: 3px;
}

.ci_t_r_message > div:nth-child(2) > div > img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.ci_t_r_message > div:nth-child(2) > span:nth-child(1) {
  color: #00000066;
  max-width: calc(100% - 100px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 25px;
  /* display: flex;
	align-items: center; */
}

.ci_t_r_m_collect {
  min-width: 23px;
  min-height: 23px;
  display: block;
  margin-top: 2px;
  margin-right: 10px;
}

.ci_t_r_m_collect > img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.ci_t_r_m_popover {
  width: 25px;
  height: 25px;
  position: relative;
}

.ci_t_r_m_popover > svg {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.ac_c_i_t_p_box {
  position: absolute;
  height: auto;
  top: 100%;
  right: 0;
  padding: 8px;
  border-radius: 2px;
  background-color: #fff;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  width: auto;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 0px 12px 0px #0000001f;
}

.ac_c_i_t_p_box > div {
  width: 80px;
  height: 30px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 16;
  /* border-radius: 5px; */
  /* font-weight: 100; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  padding-left: 5px;
}

.ac_c_i_t_p_box > div > img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.ac_c_i_t_p_box > div:hover {
  background-color: #f2f4f7;
}

.ci_t_r_brief {
  width: 100%;
  /* height: calc(100% - 80px - 10px - 10px - 10px); */
  color: #000000e5;
  margin-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #00000099;
  word-break: break-all;
}

.cardItem_bottom {
  width: 94%;
  margin: 0 auto;
  height: 50px;
  box-sizing: border-box;
  border-top: solid 1px #e7e7e7;
  display: flex;
  justify-content: space-between;
  /* background-color: yellow; */
}

.ci_b_left {
  width: calc(100% - 80px);
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  font-size: 16px !important;
}
.ci_b_left > span {
  width: 100%;
}

.ci_b_left .icon {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ci_b_left .icon-btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.ci_b_left .icon-btn:hover {
  opacity: 0.7;
}

.ci_b_left .icon-disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.ci_b_right {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ci_b_right > div {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.ci_b_right > div > span {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 60px; */
  width: auto;
  padding: 0 5px;
  height: 29px;
  font-size: 14px;
  border-radius: 4px;
  white-space: nowrap;
}

.havePublished {
  background: #effcf5;
  border: 1px solid #effcf5;
  color: #17c469;
}

.unpublish {
  background: #fff3ea;
  border: 1px solid #fff3ea;
  color: #e67f36;
}

.ci_b_l_box {
  font-size: 16px;
}

.cocoflow-dian {
  font-size: 25px;
}
.tagNowWrap {
  flex: 1; /* 占满剩余空间 */
  min-width: 0; /* 覆盖 Flex 子项默认 min-width: auto */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.your-container {
  width: calc(100% - 100px);
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.man_tagBox {
  box-sizing: border-box;
}

.m_tb_top {
  box-sizing: border-box;
  padding: 7px 12px 4px 12px;
}

.m_tb_top >>> .el-input__inner {
  background: #f1f3f6;
  border: none;
}

.m_tb_center {
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  margin: 5px 0;
  max-height: 300px;
  overflow: auto;
  box-sizing: border-box;
  padding: 10px 12px;
}

.m_tb_c_checkboxItem {
  box-sizing: border-box;
  width: calc(100%);
  overflow: hidden;
  display: flex;
  align-items: center;
}

.m_tb_c_checkboxItem > ::v-deep .el-checkbox__label {
  width: calc(100% - 20px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.m_tb_c_checkboxItem >>> .el-checkbox__input {
  height: 14px;
}

.m_tb_c_checkboxItem + .m_tb_c_checkboxItem {
  margin-top: 10px;
}

.m_tb_bottom {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  padding: 7px 12px 12px 12px;
  cursor: pointer;
}

.m_tb_bottom > svg {
  margin-right: 5px;
}

.pageLoading {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b2bfc3;
  font-size: 16px;
}

.pageLoading > img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.cocoflow-biaoqian {
  font-size: 15px;
}
.cyD{
  background: #f3f4f5;
  border: 1px solid #effcf5;
  color: #62ACDF;
}
.cyN{
  font-size: 10px;
  text-align: right;
  padding: 0 20px;
  box-sizing: border-box;
  color: #5985EC;
}
</style>
